export default __webpack_public_path__ + "static/media/tone1760.8b2b540d.mp3";